export default function Icon({color = "white", size, style, children}) {
  return <span className="material-symbols-outlined" style={{...(style || {}), color, fontSize: size, userSelect: "none" }}>{children}</span>;
}